module.exports = __webpack_public_path__ + "assets/img/pp3.7d581552.png";